import { AppScreens } from "./AppScreens"
import { DLBanner } from "./DLBanner"
import { FAQ } from "./FAQ"
import { Features } from "./Features"
import { Hero } from "./Hero"
import Locations from "./Locations"

export const Landing = () => {
  return <><Hero /><Features /><Locations /><AppScreens /><FAQ /><DLBanner /></>
}